module.exports = __webpack_public_path__ + "static/incendio-b8e5c93b304e3e26de8a8d320415871c.jpg";